import(/* webpackMode: "eager", webpackExports: ["ConsultButton"] */ "/vercel/path0/components/site/consult-button.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/about/team-bang.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/about/team-kim.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/about/team-kwak.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/about/team-park.webp");
